/* ============================================================
   HOTDIVE CLONE - 交互效果脚本
   ============================================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* === 统一的页面滚动锁(引用计数) ===
     购物车抽屉 / 移动菜单 / 搜索 / 到货通知弹窗等多个遮罩共用 body.overflow,
     用计数避免"先关的那个把还开着的那个解锁"。所有组件用 hdLockScroll/hdUnlockScroll。 */
  var __hdLocks = {};
  function hdLockScroll(key) {
    // 锁在 html(真正的滚动容器: html{overflow-x:hidden} 已使其成为滚动容器)上, 不锁 body。
    // 关键: 若给 body 设 overflow:hidden, body 会变成新的滚动容器, 令桌面端 position:sticky
    // 的画廊改以 body(scrollTop=0)为参照重新吸附 → 纵向跳动。锁 html 则冻结当前 scrollTop,
    // sticky 参照不变; 横向由 html{scrollbar-gutter:stable} 预留槽位防抖。
    __hdLocks[key] = true; // 按键名记锁, 幂等(重复 open/close 不会误解锁别人)
    document.documentElement.style.overflow = 'hidden';
  }
  function hdUnlockScroll(key) {
    delete __hdLocks[key];
    // 还原为空, 回落到 CSS 的 html{overflow-x:hidden; overflow-y:auto}
    if (Object.keys(__hdLocks).length === 0) document.documentElement.style.overflow = '';
  }

  // 模块隔离: 某模块抛错不拖垮后续模块(尤其购物车这类转化关键路径)
  function hdSafe(name, fn) {
    try { fn(); } catch (e) { if (window.console) console.error('[hotdive] ' + name + ' init failed:', e); }
  }

  /* === 滚动进入动画 (Intersection Observer) === */
  hdSafe('initScrollAnimations', function () {
    var elements = document.querySelectorAll('.os-animation');
    if (!elements.length) return;

    // 先隐藏所有 os-animation 元素
    elements.forEach(function(el) {
      el.classList.add('os-hidden');
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.remove('os-hidden');
            entry.target.classList.add('animated');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      elements.forEach(function(el) {
        observer.observe(el);
      });
    } else {
      // Fallback: 直接显示
      elements.forEach(function(el) {
        el.classList.remove('os-hidden');
        el.classList.add('animated');
      });
    }
  });

  /* === 导航栏滚动变色 === */
  hdSafe('initNavbarScroll', function () {
    var navbar = document.getElementById('hotdiveNavbar');
    if (!navbar) return;
    var template = navbar.getAttribute('data-transparent');

    if (template === 'index') {
      document.body.classList.add('hotdive-transparent-header');
    } else {
      navbar.classList.add('scrolled');
    }

    var lastScroll = 0;
    window.addEventListener('scroll', function() {
      var currentScroll = window.scrollY;
      if (currentScroll > 100) {
        navbar.classList.add('scrolled');
      } else if (template === 'index') {
        navbar.classList.remove('scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  });

  /* === 移动端菜单 === */
  hdSafe('initMobileMenu', function () {
    var menuToggle = document.getElementById('hotdiveMenuToggle');
    var menuClose = document.getElementById('hotdiveMenuClose');
    var mobileMenu = document.getElementById('hotdiveMobileMenu');
    if (!menuToggle || !mobileMenu) return;

    function closeMobileMenu() {
      mobileMenu.classList.remove('open');
      menuToggle.classList.remove('open');
      menuToggle.setAttribute('aria-expanded', 'false');
      hdUnlockScroll('menu');
      document.querySelectorAll('.hotdive-mobile-submenu.open').forEach(function(sub) {
        sub.classList.remove('open');
      });
    }

    menuToggle.addEventListener('click', function() {
      var willOpen = !mobileMenu.classList.contains('open');
      if (willOpen) {
        mobileMenu.classList.add('open');
        menuToggle.classList.add('open');
        menuToggle.setAttribute('aria-expanded', 'true');
        hdLockScroll('menu');
      } else {
        closeMobileMenu();
      }
    });

    if (menuClose) {
      menuClose.addEventListener('click', closeMobileMenu);
    }

    // Esc 关闭移动菜单
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('open')) closeMobileMenu();
    });

    // 子菜单展开(点击 + 键盘)
    document.querySelectorAll('[data-submenu]').forEach(function(link) {
      function openSub(e) {
        e.preventDefault();
        var submenu = document.getElementById('submenu-' + link.getAttribute('data-submenu'));
        if (submenu) submenu.classList.add('open');
      }
      link.addEventListener('click', openSub);
      link.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') openSub(e);
      });
    });

    // 子菜单返回(点击 + 键盘)
    document.querySelectorAll('[data-back]').forEach(function(btn) {
      function goBack() { btn.closest('.hotdive-mobile-submenu').classList.remove('open'); }
      btn.addEventListener('click', goBack);
      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goBack(); }
      });
    });
  });

  /* === 搜索浮层 === */
  hdSafe('initSearchbar', function () {
    var toggle = document.getElementById('hotdiveSearchToggle');
    var bar = document.getElementById('hotdiveSearchbar');
    var closeBtn = document.getElementById('hotdiveSearchClose');
    var input = document.getElementById('hotdiveSearchInput');
    if (!toggle || !bar) return;

    function openBar() {
      bar.classList.add('open');
      toggle.setAttribute('aria-expanded', 'true');
      hdLockScroll('search');
      if (input) setTimeout(function() { input.focus(); }, 60);
    }
    function closeBar() {
      bar.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
      hdUnlockScroll('search');
      toggle.focus();
    }

    toggle.addEventListener('click', openBar);
    if (closeBtn) closeBtn.addEventListener('click', closeBar);
    // 点击半透明遮罩区域关闭
    bar.addEventListener('click', function(e) {
      if (e.target === bar) closeBar();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && bar.classList.contains('open')) closeBar();
    });
  });

  /* === 桌面大菜单(PRODUCTS/SUPPORT/ABOUT)键盘 + 触屏可达 === */
  hdSafe('initMegaMenu', function () {
    var dropdowns = document.querySelectorAll('.hotdive-nav-dropdown-mega');
    if (!dropdowns.length) return;

    dropdowns.forEach(function(dd) {
      var trigger = dd.querySelector('.nav-btn-item-drop');
      if (!trigger) return;

      function setOpen(open) {
        dd.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      // 键盘 Enter/Space 切换(顶级 span 本身不跳转)
      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setOpen(!dd.classList.contains('is-open'));
        }
      });
      // 触屏/点击切换(桌面 hover 已可开, 这里主要兜触屏)
      trigger.addEventListener('click', function() {
        setOpen(!dd.classList.contains('is-open'));
      });
      // 焦点进出同步 aria-expanded, 焦点离开整块时收起
      dd.addEventListener('focusin', function() { trigger.setAttribute('aria-expanded', 'true'); });
      dd.addEventListener('focusout', function() {
        if (!dd.contains(document.activeElement)) setOpen(false);
      });
    });

    // 点击外部 / Esc 收起所有
    document.addEventListener('click', function(e) {
      dropdowns.forEach(function(dd) {
        if (!dd.contains(e.target)) {
          dd.classList.remove('is-open');
          var t = dd.querySelector('.nav-btn-item-drop');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
    });
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      dropdowns.forEach(function(dd) {
        if (dd.classList.contains('is-open')) {
          dd.classList.remove('is-open');
          var t = dd.querySelector('.nav-btn-item-drop');
          if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
        }
      });
    });
  });

  /* === 语言 / 国家货币切换: aria-expanded 同步(展开靠 CSS hover/focus-within) === */
  hdSafe('initLocalizationSwitch', function () {
    document.querySelectorAll('.hotdive-lang-switch').forEach(function(sw) {
      var btn = sw.querySelector('.hotdive-lang-current');
      if (!btn) return;
      function set(open) { btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      sw.addEventListener('focusin', function() { set(true); });
      sw.addEventListener('focusout', function() { if (!sw.contains(document.activeElement)) set(false); });
      sw.addEventListener('mouseenter', function() { set(true); });
      sw.addEventListener('mouseleave', function() { if (!sw.contains(document.activeElement)) set(false); });
      btn.addEventListener('click', function(e) { e.preventDefault(); btn.focus(); });
    });
  });

  /* === 移动端地区/货币: 底部 Sheet(pill 触发 + 搜索) === */
  hdSafe('initMobileLoc', function () {
    var sheet = document.getElementById('hotdiveMlocSheet');
    var openBtn = document.getElementById('hotdiveMlocOpen');
    if (!sheet || !openBtn) return;

    function openSheet() {
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      hdLockScroll('mloc');
      var active = sheet.querySelector('.hotdive-mloc-sheet__opt.active') || sheet.querySelector('.hotdive-mloc-sheet__opt');
      if (active) setTimeout(function () { active.focus(); }, 80);
    }
    function closeSheet() {
      if (!sheet.classList.contains('is-open')) return;
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      hdUnlockScroll('mloc');
      openBtn.focus();
    }

    openBtn.addEventListener('click', openSheet);
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-mloc-close]')) closeSheet();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet();
    });
  });

  /* === 产品页: Splide 画廊 + 变体选择 === */
  hdSafe('initProductPage', function () {
    // Splide 产品画廊 (主图 + 缩略图 nav, sync 联动 — SANTI 同款方案)
    var productSplide = document.getElementById('hotdiveProductSplide');
    if (productSplide && typeof Splide !== 'undefined') {
      var splide = new Splide('#hotdiveProductSplide', {
        type: 'slide',
        perPage: 1,
        arrows: false,
        pagination: true,
        gap: 0
      });

      // 缩略图 Splide: 一屏 5 个, 可横滚, 点击导航主图, active 自动滚入视区
      var thumbEl = document.getElementById('hotdiveThumbs');
      var thumbSplide = null;
      if (thumbEl) {
        thumbSplide = new Splide('#hotdiveThumbs', {
          rewind: false,
          perPage: 5,
          gap: 6,
          pagination: false,
          arrows: false,
          isNavigation: true,
          drag: true,
          focus: 0,
          breakpoints: {
            767: { perPage: 4, gap: 5 }
          }
        });
        splide.sync(thumbSplide);     // 必须在 mount 之前
      }

      splide.mount();
      if (thumbSplide) thumbSplide.mount();
    }

    // 变体选择器(无 options 商品无此数据块; 仍继续绑到货通知/售罄, 靠 SSR 渲染的售罄态兜底)
    var variantDataEl = document.getElementById('hotdiveVariantData');
    var variants = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
    var variantBtns = document.querySelectorAll('.hotdive-variant-btn');
    var variantIdInput = document.querySelector('input[name="id"]');
    var priceEl = document.querySelector('.hotdive-product-price');
    var compareEl = document.querySelector('.hotdive-product-compare');

    // 多货币: 变体切换时按当前货币格式化(不再硬编码 $)
    var curCode = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    function fmtMoney(cents) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: curCode }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    // 获取当前选中的 options
    function getSelectedOptions() {
      var options = [];
      document.querySelectorAll('.hotdive-variant-group').forEach(function(group) {
        var active = group.querySelector('.hotdive-variant-btn.active');
        options.push(active ? active.dataset.value : '');
      });
      return options;
    }

    // 根据 options 找匹配的 variant
    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < options.length; j++) {
          if (v['option' + (j + 1)] !== options[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    var atcBtn = document.querySelector('.hotdive-add-to-cart');
    var atcText = atcBtn && atcBtn.querySelector('.hotdive-add-to-cart__text');
    var buyRow = document.querySelector('.hotdive-buy-row');
    var notifyBtn = document.querySelector('.hotdive-notify-btn');

    // 设置 ADD TO CART 可用状态(防加错变体 / 防售罄下单)
    function setAtcState(state) {
      if (!atcBtn) return;
      if (state === 'add') { atcBtn.disabled = false; if (atcText) atcText.textContent = 'Add to cart'; }
      else if (state === 'soldout') { atcBtn.disabled = true; if (atcText) atcText.textContent = 'Sold out'; }
      else { atcBtn.disabled = true; if (atcText) atcText.textContent = 'Unavailable'; }
      // 售罄时展开「到货通知」按钮(与 SOLD OUT 并排, flex 过渡丝滑); 其它状态折叠隐藏
      if (buyRow) buyRow.classList.toggle('is-soldout', state === 'soldout');
    }

    // 到货通知: 自建弹窗 + 提交到 Shopify 原生 contact 表单(同源/免费/无 CORS)
    // 提交即发邮件到店铺邮箱; contact[body] 填入"产品 + 当前变体", 一眼看到谁要哪款/哪个尺码
    var bisModal = document.getElementById('hotdiveBisModal');
    if (notifyBtn && bisModal) {
      var bisForm = bisModal.querySelector('.hotdive-bis__form');
      var bisInput = bisModal.querySelector('.hotdive-bis__input');
      var bisSubmit = bisModal.querySelector('.hotdive-bis__submit');
      var bisMsg = bisModal.querySelector('.hotdive-bis__msg');

      function bisShowMsg(type, text) {
        bisMsg.textContent = text;
        bisMsg.className = 'hotdive-bis__msg hotdive-bis__msg--' + type;
        bisMsg.removeAttribute('hidden');
      }
      var bisCloseTimer = null;
      function openBis() {
        if (bisCloseTimer) { clearTimeout(bisCloseTimer); bisCloseTimer = null; } // 防关闭动画竞态
        bisMsg.setAttribute('hidden', '');
        bisForm.style.display = '';
        bisModal.removeAttribute('hidden');
        hdLockScroll('bis');
        requestAnimationFrame(function () { bisModal.classList.add('is-open'); });
        setTimeout(function () { if (bisInput) bisInput.focus(); }, 280);
      }
      function closeBis() {
        bisModal.classList.remove('is-open');
        hdUnlockScroll('bis');
        if (bisCloseTimer) clearTimeout(bisCloseTimer);
        bisCloseTimer = setTimeout(function () { bisModal.setAttribute('hidden', ''); bisCloseTimer = null; }, 320);
        if (notifyBtn) notifyBtn.focus(); // 关闭后焦点归还触发按钮
      }

      notifyBtn.addEventListener('click', openBis);
      bisModal.querySelectorAll('[data-bis-close]').forEach(function (el) {
        el.addEventListener('click', closeBis);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !bisModal.hasAttribute('hidden')) closeBis();
      });

      function submitBis() {
        if (bisSubmit.classList.contains('is-loading')) return;
        var email = (bisInput.value || '').trim();
        if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
          bisShowMsg('error', 'Please enter a valid email address.');
          bisInput.focus();
          return;
        }
        // 把当前选中变体(尺码/规格)写进邮件正文, 店铺收到的邮件一眼看到要哪个变体
        var bodyInput = bisForm.querySelector('[data-bis-base]');
        if (bodyInput) {
          var base = bodyInput.getAttribute('data-bis-base') || 'Back-in-stock request';
          var v = findVariant(getSelectedOptions());
          var vtitle = (v && v.title) ? v.title : getSelectedOptions().join(' / ');
          vtitle = String(vtitle).trim();
          bodyInput.value = base + (vtitle && vtitle !== 'Default Title' ? ' — ' + vtitle : '');
        }

        bisSubmit.classList.add('is-loading');
        bisMsg.setAttribute('hidden', '');
        var action = bisForm.getAttribute('action') || '/contact';
        fetch(action, {
          method: 'POST',
          body: new FormData(bisForm),
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          redirect: 'follow'
        }).then(function (res) {
          return res.text().then(function (html) { return { res: res, html: html }; });
        }).then(function (out) {
          bisSubmit.classList.remove('is-loading');
          var res = out.res, html = out.html || '';
          var posted = /(contact|customer)_posted=true/.test(res.url || '');
          var errText = '';
          try {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var errNode = doc.querySelector('.form__message, .errors, .form-status');
            if (errNode) errText = (errNode.textContent || '').trim();
          } catch (_) {}
          var already = /already|taken/i.test(errText); // 已存在也算成功
          // 仅当有明确成功信号(Shopify 成功后 302→contact_posted=true)或"已存在"才算成功;
          // 其余(含 dev 401、未知 200)一律保守报错, 避免把失败误显示为"已订阅"
          if (posted || already) {
            bisForm.style.display = 'none';
            bisShowMsg('success', "You're on the list — we'll email you the moment it's back.");
          } else if (errText) {
            bisShowMsg('error', errText);
          } else {
            bisShowMsg('error', 'Something went wrong. Please try again later.');
          }
        }).catch(function () {
          bisSubmit.classList.remove('is-loading');
          bisShowMsg('error', 'Network error. Please try again.');
        });
      }

      // 多重保险, 杜绝原生提交跳转: 按钮点击 + 回车 + 表单 submit 全部走 AJAX
      bisSubmit.addEventListener('click', submitBis);
      bisForm.addEventListener('submit', function (e) { e.preventDefault(); submitBis(); });
      bisInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submitBis(); }
      });
    }

    // 更新价格和 URL
    function updateVariant(variant) {
      // 组合不存在: 禁用加购, 清空 id, 防止加到上一个变体
      if (!variant) {
        if (variantIdInput) variantIdInput.value = '';
        setAtcState('unavailable');
        return;
      }
      if (variantIdInput) {
        variantIdInput.value = variant.id;
        // 派发 change 事件: 让到货通知/动态结账按钮等监听到变体切换
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // 售罄: 禁用加购
      setAtcState(variant.available ? 'add' : 'soldout');
      if (priceEl) {
        priceEl.textContent = fmtMoney(variant.price);
      }
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = fmtMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      // 更新 URL
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      // 如果有 Splide, 跳到该变体关联的图片
      if (productSplide && splide) {
        var slides = document.querySelectorAll('#hotdiveProductSplide .splide__slide');
        var jumped = false;
        // 优先: 用 Shopify 算好的「变体→图」关系 (data-variant-ids), 后台绑图后最准
        slides.forEach(function(slide, idx) {
          if (jumped) return;
          var ids = (slide.getAttribute('data-variant-ids') || '').split(',');
          if (ids.indexOf(String(variant.id)) !== -1) { splide.go(idx); jumped = true; }
        });
        // 兜底: 按图片文件名匹配
        if (!jumped && variant.featured_image) {
          var fname = variant.featured_image.src.split('?')[0].split('/').pop();
          slides.forEach(function(slide, idx) {
            if (jumped) return;
            var img = slide.querySelector('img');
            if (img && img.src.indexOf(fname) !== -1) { splide.go(idx); jumped = true; }
          });
        }
      }
    }

    // 按钮点击事件
    variantBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = this.closest('.hotdive-variant-group');
        group.querySelectorAll('.hotdive-variant-btn').forEach(function(b) {
          b.classList.remove('active');
          b.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('active');
        this.setAttribute('aria-pressed', 'true');

        var options = getSelectedOptions();
        var variant = findVariant(options);
        updateVariant(variant);
      });
    });

    // 初始化: 同步当前选中变体的可用状态(首屏即售罄则禁用加购)
    // 用双 rAF 延后应用 → 让「到货通知」按钮的折叠态先绘制, 首次进入售罄页也能播放展开动画
    // 仅多变体商品跑; 无 options 商品靠 SSR 渲染的售罄态, 不在此覆盖(否则会误判 unavailable)
    if (variantDataEl) {
      (function () {
        var initVariant = findVariant(getSelectedOptions());
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { updateVariant(initVariant); });
        });
      })();
    }

    // 缓存陈旧防线: 若首屏渲染成"售罄"(SSR 把 available 烘进了可缓存 HTML),
    // 就用实时库存复核, 避免 CDN/浏览器缓存把"其实有货"错显成售罄而丢单。
    // 仅在售罄态才发这一个请求 → 有货商品(绝大多数)零额外开销;
    // ?_= 时间戳同时绕过浏览器与 CDN 缓存, 直取源站实时数据。
    if (atcBtn && atcBtn.disabled) {
      var hd_h = (location.pathname.split('/products/')[1] || '').split('?')[0].split('/')[0];
      if (hd_h) {
        fetch('/products/' + hd_h + '.js?_=' + Date.now())
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (fresh) {
            if (!fresh || !fresh.variants) return;
            variants = fresh.variants;   // 用实时库存覆盖内联(可能缓存陈旧)的变体数据
            if (variantDataEl) {
              updateVariant(findVariant(getSelectedOptions()));
            } else if (atcBtn) {
              // 无 options 商品: 直接按实时 available 校正
              setAtcState(fresh.available ? 'add' : 'soldout');
            }
          })
          .catch(function () {});
      }
    }
  });

  /* === Go Up 按钮 === */
  hdSafe('initGoUp', function () {
    var goUp = document.querySelector('.hotdive-ft-goup');
    if (goUp) {
      goUp.addEventListener('click', function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  });

  /* === 购物车: AJAX 加购 + 自定义抽屉 === */
  hdSafe('initCart', function () {
    var cartEl = document.getElementById('hdCart');
    if (!cartEl) return;
    var body = document.getElementById('hdCartBody');
    var foot = document.getElementById('hdCartFoot');
    var countEl = document.getElementById('hdCartCount');
    var subtotalEl = document.getElementById('hdCartSubtotal');
    var bubble = document.getElementById('hdCartCountBubble');
    var toggle = document.getElementById('hdCartToggle');
    var busy = false;
    var lastSig = '';

    var currencyCode = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    function money(cents) {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function imgUrl(src) {
      if (!src) return '';
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    }
    function openCart() {
      cartEl.classList.add('is-open');
      cartEl.setAttribute('aria-hidden', 'false');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      hdLockScroll('cart');
    }
    function closeCart() {
      cartEl.classList.remove('is-open');
      cartEl.setAttribute('aria-hidden', 'true');
      if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
      hdUnlockScroll('cart');
    }

    function render(cart) {
      // 多货币: 以购物车返回的实际货币为准(Markets 切换后实时)
      if (cart.currency) currencyCode = cart.currency;
      // 防御: 只渲染数量>0 的行, 脏数据里的 0 数量幽灵行不显示
      var items = (cart.items || []).filter(function(it){ return it.quantity > 0; });
      var n = cart.item_count;
      if (countEl) countEl.textContent = '[' + n + '] ' + (n === 1 ? 'PRODUCT' : 'PRODUCTS');
      if (bubble) {
        bubble.textContent = n;
        if (n > 0) bubble.removeAttribute('hidden'); else bubble.setAttribute('hidden', '');
      }
      // 内容签名(含小计, 价格变化也刷新): 未变化则不重写 body, 避免重建图片闪烁
      var sig = n + '|' + cart.items_subtotal_price + '|' + items.map(function(it){ return it.key + ':' + it.quantity; }).join(',');
      if (sig === lastSig) return;
      lastSig = sig;
      if (!items.length) {
        body.innerHTML = '<p class="hd-cart__empty">Your cart is empty.</p>';
        foot.setAttribute('hidden', '');
        return;
      }
      foot.removeAttribute('hidden');
      subtotalEl.textContent = money(cart.items_subtotal_price);
      var html = '';
      items.forEach(function(item) {
        var url = esc(item.url);
        html += '<div class="hd-cart-item" data-key="' + esc(item.key) + '">'
          + '<a class="hd-cart-item__img" href="' + url + '">'
          + (item.image ? '<img src="' + esc(imgUrl(item.image)) + '" alt="" loading="lazy">' : '')
          + '</a>'
          + '<div class="hd-cart-item__info">'
          + '<a class="hd-cart-item__title" href="' + url + '">' + esc(item.product_title) + '</a>'
          + (item.variant_title ? '<div class="hd-cart-item__variant">' + esc(item.variant_title) + '</div>' : '')
          + '<div class="hd-cart-item__qty">'
          + '<button type="button" class="hd-qty-btn" data-cart-minus aria-label="Decrease">−</button>'
          + '<span class="hd-qty-num">' + item.quantity + '</span>'
          + '<button type="button" class="hd-qty-btn" data-cart-plus aria-label="Increase">+</button>'
          + '<button type="button" class="hd-cart-item__remove" data-cart-remove aria-label="Remove">'
          + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/></svg>'
          + '</button>'
          + '</div>'
          + '</div>'
          + '<div class="hd-cart-item__line">' + money(item.final_line_price) + '</div>'
          + '</div>';
      });
      body.innerHTML = html;
    }

    function fetchCart() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r) { return r.json(); });
    }
    function refresh() { return fetchCart().then(render).catch(function(){}); }
    function changeItem(key, quantity) {
      if (busy) return;
      busy = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function(r) { return r.json(); })
        .then(render)
        .catch(function(){ return refresh(); })
        .then(function() { busy = false; });
    }

    if (toggle) toggle.addEventListener('click', function() { openCart(); refresh(); });
    cartEl.querySelectorAll('[data-cart-close]').forEach(function(el) {
      el.addEventListener('click', closeCart);
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && cartEl.classList.contains('is-open')) closeCart();
    });

    body.addEventListener('click', function(e) {
      var itemEl = e.target.closest('.hd-cart-item');
      if (!itemEl || busy) return;
      var key = itemEl.getAttribute('data-key');
      var num = parseInt(itemEl.querySelector('.hd-qty-num').textContent, 10);
      var nq = null;
      if (e.target.closest('[data-cart-plus]')) nq = num + 1;
      else if (e.target.closest('[data-cart-minus]')) nq = Math.max(0, num - 1);
      else if (e.target.closest('[data-cart-remove]')) nq = 0;
      if (nq === null) return;
      itemEl.classList.add('is-updating');   // 处理中动画(render 重写后自然消失)
      changeItem(key, nq);
    });

    // 加购拦截 (产品页) — JS 变量真锁 + 异常降级原生提交
    var addBtn = document.querySelector('.hotdive-add-to-cart');
    var addForm = addBtn && addBtn.closest('form');
    var addBusy = false;
    if (addForm) {
      addForm.addEventListener('submit', function(e) {
        e.preventDefault();
        if (addBusy) return;
        try {
          addBusy = true;
          addBtn.classList.add('is-loading');
          var fd = new FormData(addForm);
          fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
            .then(function(r) {
              if (!r.ok) return r.json().then(function(err) { throw err; });
              return r.json();
            })
            .then(function() { return refresh(); })
            .then(function() {
              addBtn.classList.remove('is-loading');
              addBtn.classList.add('is-added');
              openCart();
              setTimeout(function() {
                addBtn.classList.remove('is-added');
                addBusy = false;
              }, 1600);
            })
            .catch(function(err) {
              addBtn.classList.remove('is-loading');
              addBusy = false;
              alert((err && err.description) || 'Could not add to cart.');
            });
        } catch (ex) {
          // JS 异常兜底: 退回原生提交, 保证用户始终能加购
          addBtn.classList.remove('is-loading');
          addBusy = false;
          addForm.submit();
        }
      });
    }

    // 页面加载即预渲染; bfcache(浏览器返回)也刷新, 避免气泡/内容过期
    refresh();
    window.addEventListener('pageshow', function(e) { if (e.persisted) refresh(); });
  });

  /* === 移动菜单 Account: 触发右上角 shopify-account, 行为与之一致 === */
  hdSafe('initMobileAccount', function () {
    var trigger = document.querySelector('[data-mobile-account]');
    if (!trigger) return;
    trigger.addEventListener('click', function(e) {
      var acct = document.querySelector('.hotdive-account-wrapper shopify-account');
      if (acct) {
        e.preventDefault();
        var inner = acct.shadowRoot && acct.shadowRoot.querySelector('a, button');
        (inner || acct).click();
      }
      // 无组件(customer accounts 未启用)时不拦截, 走 href account_url 降级
    });
  });

  /* === 售后中心(dealers)移动端: Category / Country 可折叠 === */
  hdSafe('initDealerAccordion', function () {
    var titles = document.querySelectorAll('.hd-dealers-sidebar .hd-search-title');
    if (!titles.length) return;
    function isMobile() { return window.innerWidth <= 900; }
    titles.forEach(function(t) {
      t.addEventListener('click', function() {
        if (!isMobile()) return;
        var panel = t.nextElementSibling;
        if (panel && panel.classList.contains('hd-category-sidebar')) {
          panel.classList.toggle('is-collapsed');
          t.classList.toggle('is-open');
        }
      });
    });
    function applyInitial() {
      var collapse = isMobile();
      document.querySelectorAll('.hd-dealers-sidebar .hd-category-sidebar').forEach(function(p) {
        p.classList.toggle('is-collapsed', collapse);
      });
      titles.forEach(function(t) { t.classList.toggle('is-open', !collapse); });
    }
    applyInitial();
    var rt;
    window.addEventListener('resize', function() { clearTimeout(rt); rt = setTimeout(applyInitial, 150); });
  });

  /* === 页脚邮件订阅: 原生表单提交(兼容 Shopify 反垃圾验证) ===
     线上店铺 Shopify 会给 customer 表单注入 captcha 脚本并接管提交流程,
     AJAX 拦截会与其冲突(先报错→页面跳转→才成功)。
     因此只做两件事: 提交时按钮转圈反馈; 提交成功回跳后把成功消息滚动到视野内。 */
  hdSafe('initNewsletter', function () {
    var forms = document.querySelectorAll('.hotdive-nl-form form');

    forms.forEach(function(form) {
      if (form.dataset.hdNlBound) return;
      form.dataset.hdNlBound = '1';
      var btn = form.querySelector('.hotdive-nl-btn');
      if (!btn) return;

      // 原生提交照常进行, 只切换按钮为 loading 态防止重复点击
      form.addEventListener('submit', function() {
        if (btn.classList.contains('is-loading')) return;
        btn.classList.add('is-loading');
        btn.innerHTML = '<span class="hotdive-nl-spinner" aria-hidden="true"></span>';
      });
    });

    // 提交成功回跳(URL 带 customer_posted=true)后, 确保成功消息出现在视野内
    if (/customer_posted=true/.test(window.location.search)) {
      var success = document.querySelector('.hotdive-nl-success');
      if (success) {
        requestAnimationFrame(function() {
          success.scrollIntoView({ block: 'center' });
        });
      }
    }
  });

});
